module.exports = __webpack_public_path__ + "img/plan3M.b5e6d3a3.png";